import { createSelector } from '@reduxjs/toolkit';
import { StateType } from '../../../types';

export const getGlobalSystemInfo = createSelector(
  (state: StateType) => state.app,
  (app) => app.globalSystemInfo?.data,
);
